"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUniqueId = void 0;
const react_1 = require("react");
const gmOptsContext_1 = __importDefault(require("./gmOptsContext"));
function useUniqueId() {
    const idRef = (0, react_1.useRef)(null);
    if (idRef.current === null) {
        idRef.current = Math.random();
    }
    return idRef.current;
}
exports.useUniqueId = useUniqueId;
/**
 * React hook for accepting global markup options objects and sending them to a context provider to be merged together
 */
const useGlobalMarkupOptions = (gmOptions) => {
    const id = useUniqueId();
    const context = (0, react_1.useContext)(gmOptsContext_1.default) || {};
    const emitChange = () => {
        const { setGMOptions } = context;
        if (!setGMOptions)
            return;
        setGMOptions(id, gmOptions);
    };
    (0, react_1.useEffect)(() => () => {
        // componentWillUnmount
        const { GlobalMarkupOptionsInstances } = context;
        if (!GlobalMarkupOptionsInstances)
            return;
        GlobalMarkupOptionsInstances.remove(id);
    }, []);
    // useEffect doesn't run in SSR, so call emitChange here
    emitChange();
};
exports.default = useGlobalMarkupOptions;
//# sourceMappingURL=useGlobalMarkupOptions.js.map